import './App.css';
import Navbar from './components/header/Navbar';
import Hero from './components/hero/Hero';
import CarLogo from './components/car-logos/Car-logo';
import BenefitSection from './components/benefit-section/Benefit-section';
import HowItWroks from './components/how-it-works/How-it-works';
import Faq from './components/faq/Faq';
import Footer from './components/footer/Footer';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Navbar />
      </header>
      <main>
        <Hero />
        <CarLogo />
        <BenefitSection />
        <HowItWroks />
        <Faq />
        <Footer />
      </main>
    </div>
  );
}

export default App;
